import { render, staticRenderFns } from "./WavePath.vue?vue&type=template&id=26b9a300"
import script from "./WavePath.vue?vue&type=script&lang=ts"
export * from "./WavePath.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports